import { render, staticRenderFns } from "./GuestSelect.vue?vue&type=template&id=2b1aa8a6&scoped=true&"
import script from "./GuestSelect.vue?vue&type=script&lang=js&"
export * from "./GuestSelect.vue?vue&type=script&lang=js&"
import style0 from "./GuestSelect.vue?vue&type=style&index=0&id=2b1aa8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1aa8a6",
  null
  
)

export default component.exports